module.exports = __webpack_public_path__ + "img/res-icon-10.bd93e9eb.png";